import { filter } from 'lodash'
import { combineReducers } from 'redux'
import { loadingReducer } from 'redux-foundry'
import { API_LISTAR_REGIOES_HIDROGRAFICAS,
  API_CRIAR_REGIOES_HIDROGRAFICAS,
  API_EXCLUIR_REGIOES_HIDROGRAFICAS,
  API_ATUALIZAR_REGIOES_HIDROGRAFICAS } from 'store/modules/api/regioesHidrograficas.actions'

const lista = (state = [], { type, payload }) => {
  switch (type) {
    case API_LISTAR_REGIOES_HIDROGRAFICAS.success:
      return payload.sort((a, b) => a.nome.localeCompare(b.nome))
    case API_CRIAR_REGIOES_HIDROGRAFICAS.success:
      return [...state, payload].sort((a, b) => a.nome.localeCompare(b.nome))
    case API_ATUALIZAR_REGIOES_HIDROGRAFICAS.success:
      return state.map((e) => (e.id === payload.id ?
        payload : e))
    case API_EXCLUIR_REGIOES_HIDROGRAFICAS.success:
      return filter(state, (o) => o.id !== Number(payload))
    default: return state
  }
}

const isCarregandoLista = loadingReducer(false, API_LISTAR_REGIOES_HIDROGRAFICAS)

const isSaving = loadingReducer(false, API_CRIAR_REGIOES_HIDROGRAFICAS)
const isUpdate = loadingReducer(false, API_ATUALIZAR_REGIOES_HIDROGRAFICAS)

export default combineReducers({
  lista,
  isCarregandoLista,
  isSaving,
  isUpdate,
})
